export * from './People3Icon';
export * from './People3Icon16Light';
export * from './People3Icon16Regular';
export * from './People3Icon16Solid';
export * from './People3Icon20Light';
export * from './People3Icon20Regular';
export * from './People3Icon20Solid';
export * from './People3Icon24Regular';
export * from './People3Icon24Solid';
export * from './People3Icon32Regular';
export * from './People3Icon64Regular';
